<template>
  <div>
    <v-img v-if="!ok" :src="require('../../assets/croix.png')" height="40"  aspect-ratio="1" contain />
    <v-img v-if="ok" :src="require('../../assets/coche.png')" height="40" aspect-ratio="1" contain />
  </div>
</template>

<script>
export default {
  props: {
    ok: Boolean
  }
}
</script>